import { ActionTypes } from "@/actions";

const initialState: any = {
    itemMenuIndex: 1,
    debugMode: false,
    darkMode: false,
    reloadConfigNonce: 0
}

const uiReducer = (state = initialState, action: any) => {
    switch (action.type) {


        case ActionTypes.UI_UPDATE_MENU_INDEX:
            return {
                ...state,
                itemMenuIndex: action.payload,
            };

        case ActionTypes.UI_TOGGLE_DEBUG:
            return {
                ...state,
                debugMode: !state.debugMode,
            };

        case ActionTypes.UI_TOGGLE_DARK_MODE:
            return {
                ...state,
                darkMode: !state.darkMode,
            };

        case ActionTypes.UI_SET_DARK_MODE:
            return {
                ...state,
                darkMode: action.payload,
            };

        case ActionTypes.UI_RELOAD_CONFIG:
            return {
                ...state,
                reloadConfigNonce: (state.reloadConfigNonce || 0) + 1,
            };

        default:
            return state;
    }
}

export default uiReducer;